export const AREA_TOLERANCE_M2 = 5;
export const PRICE_TOLERANCE_PERCENT = 0.05;
export const MIN_UNIQUE_PROPERTIES_FOR_CONDO = 2;
export const MAX_CONDO_MERGE_DISTANCE_METERS = 50;

export const MIN_CONDO_NAME_LENGTH = 3;
export const MAX_CONDO_NAME_LENGTH = 40;
export const MIN_WORD_LENGTH = 2;

export const COLORS = {
  selected: '#52c41a',
  unselected: '#ff4d4f',
  condominium: '#722ed1',
  partial: '#faad14',
  neutral: '#d9d9d9',
  primary: '#1890ff',
} as const;

export const CONDOMINIUM_PATTERNS: RegExp[] = [
  /(?:no|do|em)\s+(?:edif[ií]cio|ed\.?)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /[-–]\s*(?:edif[ií]cio|ed\.?)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /^(?:edif[ií]cio|ed\.?)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /(?:no|do|em)\s+(?:condom[ií]nio|cond\.?)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /[-–]\s*(?:condom[ií]nio|cond\.?)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /^(?:condom[ií]nio|cond\.?)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /residencial\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /[-–]\s*residencial\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /vila\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /torres?\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /(?:park|parque)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /plaza\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /(?:flat|loft)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /(?:home|gardens?|square|center|centre|place)\s+([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*){0,2})/i,
  /([a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*(?:\s+[a-záàâãéêíóôõúçA-Z][a-záàâãéêíóôõúçA-Z0-9]*)?)\s+(?:home|gardens?|square|center|centre|place|living|life)$/i,
];

export const IGNORE_WORDS: string[] = [
  'apartamento', 'apto', 'casa', 'sobrado', 'terreno', 'lote',
  'com', 'sem', 'novo', 'nova', 'venda', 'aluguel', 'quartos',
  'dormitorios', 'suites', 'vagas', 'garagem', 'metro', 'metros',
  'm2', 'm²', 'area', 'bairro', 'centro', 'pronto', 'entrega',
  'garden', 'cobertura', 'duplex', 'triplex', 'penthouse',
  'mobiliado', 'mobiliada', 'decorado', 'decorada',
  'alto', 'padrao', 'luxo', 'premium',
  'dorms', 'dorm', 'dormitorio', 'suite', 'banheiro', 'banheiros',
  'vaga', 'na', 'no', 'em', 'de', 'do', 'da', 'para', 'por',
  'cidade', 'regiao', 'local', 'proximo', 'perto',
];

export const GENERIC_NAMES: string[] = [
  'norte', 'sul', 'leste', 'oeste', 'central', 'centro',
  'morumbi', 'moema', 'brooklin', 'campo belo', 'itaim bibi', 'itaim',
  'vila mariana', 'mariana', 'saude', 'saúde', 'jabaquara', 'interlagos',
  'santo amaro', 'socorro', 'cidade dutra', 'grajau', 'grajaú', 'parelheiros',
  'capao redondo', 'capão redondo', 'jardim angela', 'jardim ângela',
  'campo limpo', 'vila andrade', 'andrade', 'chacara santo antonio',
  'pinheiros', 'vila madalena', 'madalena', 'perdizes', 'pompeia', 'pompéia',
  'lapa', 'barra funda', 'alto de pinheiros', 'butanta', 'butantã',
  'rio pequeno', 'raposo tavares', 'jaguare', 'jaguaré', 'vila leopoldina',
  'leopoldina', 'vila sonia', 'sônia', 'morumbi sul',
  'santana', 'tucuruvi', 'mandaqui', 'casa verde', 'limao', 'limão',
  'freguesia do o', 'freguesia do ó', 'pirituba', 'jaragua', 'jaraguá',
  'brasilandia', 'brasilândia', 'cachoeirinha', 'tremembé', 'tremembe',
  'horto florestal', 'vila guilherme', 'guilherme', 'vila maria', 'maria',
  'vila medeiros', 'medeiros', 'jaçanã', 'jacana',
  'tatuape', 'tatuapé', 'mooca', 'belem', 'belém', 'bras', 'brás',
  'penha', 'vila matilde', 'matilde', 'aricanduva', 'carrão', 'carrao',
  'itaquera', 'guaianases', 'cidade tiradentes', 'sao mateus', 'são mateus',
  'sapopemba', 'sao miguel', 'são miguel', 'ermelino matarazzo',
  'vila formosa', 'formosa', 'vila prudente', 'prudente', 'ipiranga',
  'agua rasa', 'água rasa', 'vila alpina', 'alpina', 'parque do carmo',
  'se', 'sé', 'republica', 'república', 'consolacao', 'consolação',
  'bela vista', 'liberdade', 'aclimacao', 'aclimação', 'cambuci',
  'santa cecilia', 'santa cecília', 'bom retiro', 'higienopolis', 'higienópolis',
  'pacaembu', 'jardim paulista', 'paulista', 'jardins', 'cerqueira cesar',
  'paraiso', 'paraíso',
  'santo andre', 'santo andré', 'sao bernardo', 'são bernardo',
  'sao caetano', 'são caetano', 'diadema', 'maua', 'mauá',
  'ribeirao pires', 'ribeirão pires', 'rio grande da serra',
  'guarulhos', 'osasco', 'barueri', 'alphaville', 'tambore', 'tamboré',
  'santana de parnaiba', 'santana de parnaíba', 'cotia', 'taboao', 'taboão',
  'embu', 'itapecerica', 'carapicuiba', 'carapicuíba', 'jandira',
  'itapevi', 'suzano', 'mogi das cruzes', 'ferraz de vasconcelos',
  'aruja', 'arujá', 'mairipora', 'mairiporã', 'caieiras', 'franco da rocha',
  'francisco morato', 'cajamar',
  'olimpia', 'olímpia', 'romana', 'clementino', 'zelina',
  'curuca', 'curuçá', 'ema', 'ré', 're', 'dalila', 'santa catarina',
  'esperanca', 'esperança', 'nova cachoeirinha', 'sabrina', 'nilo',
  'batel', 'agua verde', 'água verde', 'bigorrilho', 'champagnat',
  'centro civico', 'centro cívico', 'alto da gloria', 'alto da glória',
  'alto da xv', 'alto da rua xv', 'juveve', 'juvevê', 'cabral', 'ahu', 'ahú',
  'jardim social', 'jardim das americas', 'jardim das américas',
  'portao', 'portão', 'santa quiteria', 'santa quitéria', 'fazendinha',
  'novo mundo', 'xaxim', 'pinheirinho', 'sitio cercado', 'sítio cercado',
  'boqueirao', 'boqueirão', 'uberaba', 'cajuru', 'tatuquara',
  'cic', 'cidade industrial', 'santa felicidade', 'pilarzinho',
  'boa vista', 'bacacheri', 'tingui', 'tingüi', 'atuba', 'bairro alto',
  'santa candida', 'abranches', 'cachoeira', 'barreirinha', 'sao lourenco',
  'são lourenço', 'merces', 'mercês', 'vista alegre', 'cascatinha',
  'seminario', 'seminário', 'campina do siqueira', 'mossungue', 'mossunguê',
  'orleans', 'guaira', 'guaíra', 'parolin', 'prado velho', 'reboucas', 'rebouças',
  'cristo rei', 'jardim botanico', 'jardim botânico', 'hugo lange',
  'capao raso', 'capão raso', 'lindoia', 'lindóia', 'fanny', 'guabirotuba',
  'hauer', 'vila izabel', 'izabel', 'vila fanny', 'sao braz', 'são braz',
  'butiatuvinha', 'lamenha pequena', 'sao joao', 'são joão',
  'campo comprido', 'augusta', 'riviera', 'umbara', 'umbarã', 'ganchinho',
  'campo de santana', 'caximba', 'alto boqueirão', 'alto boqueirao',
  'sao jose dos pinhais', 'são josé dos pinhais', 'colombo', 'pinhais',
  'araucaria', 'araucária', 'campo largo', 'almirante tamandare',
  'almirante tamandaré', 'fazenda rio grande', 'piraquara', 'quatro barras',
  'campina grande do sul', 'bocaiuva do sul', 'rio branco do sul',
  'itaperucu', 'itaperuçu', 'campo magro', 'mandirituba', 'contenda',
  'balsa nova', 'tijucas do sul',
  'brasil', 'brazil', 'america', 'europa',
  'premium', 'prime', 'gold', 'platinum', 'diamond',
  'master', 'grand', 'royal', 'imperial',
  'new', 'novo', 'nova',
  'modern', 'moderno', 'moderna',
  'classic', 'classico', 'clássico', 'classica', 'clássica',
  'exclusive', 'exclusivo', 'exclusiva',
  'luxury', 'luxo', 'luxuoso', 'luxuosa',
  'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x',
];

export const SOURCE_LOGO_MAP: Record<string, string> = {
  vivareal: '/assets/vivareal.png',
  zapimoveis: '/assets/zap.png',
  chavesnamao: '/assets/chavesnamao.png',
  imovelweb: '/assets/imovelweb.png',
};
